import template from './template.html'

angular
  .module('contabilidad.asociarfacturas')
  .component('contabilidadAsociarfacturasLista', {
    bindings: {
      busqueda: '<',
    },
    template,
    controller: Controller,
  })

Controller.$inject = ['$q', 'ContabilidasAsociarFacturas']

function Controller ($q, ContabilidasAsociarFacturas) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.asociar = asociar
  $ctrl.eliminar = eliminar

  function $onInit () {
    $ctrl.asociando = false
    $ctrl.facturasasociadas = false
    $ctrl.$promise = ContabilidasAsociarFacturas.getListado($ctrl.busqueda).then(function (resolve) {
      $ctrl.data = resolve.data
    })
  }

  function asociar () {
    $ctrl.asociando = true
    var data = $ctrl.data.filter(function (item) {
      return item.movimientos_emisor && item.movimientos_receptor
    })
    ContabilidasAsociarFacturas.asignarFacturas($ctrl.busqueda, data).then(function (resolve) {
      $ctrl.facturasasociadas = true
      $ctrl.asociando = false
    })
  }

  function eliminar (item) {
    $ctrl.data.splice($ctrl.data.indexOf(item), 1)
  }
}




// WEBPACK FOOTER //
// ./src/contabilidad/asociarfacturas/components/lista/component.js